import React from 'react';
import Link from 'next/link';
import jsCookie from 'js-cookie';

import getConfig from 'next/config';

import styles from './EditButton.module.scss';

const { CMS_URL } = getConfig().publicRuntimeConfig;

const EditButton = ({ postId }) => {
  const LP_TOKEN = jsCookie.get('LP_TOKEN');
  const URL = `${CMS_URL}wp-admin/post.php?post=${postId}&action=edit`;

  return LP_TOKEN ? (
    <Link href={URL}>
      <a className={styles.buttonEdit} target="_blank">
        <i className="lifepal-edit" />
      </a>
    </Link>
  ) : (
    <></>
  );
};

export default EditButton;
